import React, { useState } from 'react';
import './LoginRegister.css';
import { API_BASE } from '../../api/config';

export default function ResetPassword() {
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState(null);
  const [error, setError] = useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setStatus('Sending...');
    setError(null);

    try {
      const res = await fetch(`${API_BASE}/api/auth/reset-password`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email }),
      });

      const data = await res.json();

      if (!res.ok) {
        throw new Error(data.message || 'Request failed');
      }

      setStatus(data.message);
    } catch (err) {
      console.error('❌ Reset error:', err);
      setError('Something went wrong. Please try again later.');
      setStatus(null);
    }
  };

  return (
    <div className="auth-container">
      <form onSubmit={handleSubmit}>
        <h2>Reset Your Password</h2>
        <input
          type="email"
          name="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit">Send Reset Link</button>
        {status && <p className="status-message">{status}</p>}
        {error && <p className="error-message">{error}</p>}
      </form>
      <div className="auth-links">
        <p>
          Don’t have an account? <a href="/register">Register here</a>
        </p>
        <p>
          Already have an account? <a href="/login">Login here</a>
        </p>
      </div>
    </div>
  );
}
